import { ListRisultatoProvaFinaleDTO } from './../../model/newModel';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';
import { AddUpdateSessioneOlaStudenteCommand } from '../../model/command-model';
import { AStudenteService } from '../../pages/administrator-page/studente/a-studente.service';
import { SelectDTO } from 'src/app/model/newModel';
import { SharedService } from 'src/app/shared/shared.service';
@Component({
  selector: 'app-storico-prova-finale-modal',
  templateUrl: './storico-prova-finale-modal.component.html',
  styleUrls: ['./storico-prova-finale-modal.component.css']
})
export class StoricoProvaFinaleModalComponent
extends AbstractBaseComponent
implements AfterViewInit, OnInit, OnDestroy {
  listRisultato: ListRisultatoProvaFinaleDTO;
constructor(
  public ngxSmartModalService: NgxSmartModalService,
  private aStudenteService: AStudenteService
) {
  super();
}

ngOnInit() {
 super.ngOnInit();

}

ngOnDestroy(): void {
  super.ngOnDestroy();
}

ngAfterViewInit(): void {
  super.ngAfterViewInit();
}

}

